import React, { useState, useEffect } from "react";
import Feedback from "../FunctionComponents/Feedback";
import "./Floaticons.css";
function Floaticons() {
  return (
    <>
      <div className="float-wrap">
          <Feedback /> 
          <div className="float-box box2">
                <p>
                  <a href="https://cop.accenture.com/#/global" target="_blank">
                    <img
                      src={process.env.PUBLIC_URL + "/images/Feedback/COP.png"}
                      alt="Feedback icon"
                      className="float-icons"
                    />
                    COP
                  </a>
                </p>
          
              </div>
      </div>
    </>
  );
}

export default Floaticons;
